module.exports = __webpack_public_path__ + "static/img/ws.9dcd85be.svg";